<template>

  <v-row class="pa-0">
    <v-col cols="12" class="d-flex align-center flex-row">
      <v-switch v-model="properties.predato" label="Predato" color="success" inset class="mr-4"
          hide-details />
    </v-col>
  </v-row>
  <template v-if="properties.predato">
    <p class="text-title-large">Preda</p>
    <!-- <v-switch v-model="properties.consumato" label="Consumato" color="success" inset class="mb-6"
    hide-details :indeterminate="properties.consumato === null" @click="clearSwitch($event, 'consumato')" /> -->
    
    <v-select v-model="properties.predaspeciefauna_id" :items="predaspeciefauna" label="Specie" hide-details class="mb-6"
    item-title="label" />
    
    <v-select v-model="properties.predasesso_id" :items="predasesso" label="Sesso" hide-details   item-title="label"  class="mb-6" />
    
        <v-switch v-model="properties.consumato" label="Consumato" color="success" inset class="mb-6"
            hide-details />


    <v-switch v-model="properties.predagiovane" label="Giovane" color="success" inset class="mb-6"
        hide-details />
    <!-- <v-switch v-model="properties.predagiovane" label="Giovane" color="success" inset class="mb-6"
        hide-details :indeterminate="properties.predagiovane === null" @click="clearSwitch($event, 'predagiovane')" /> -->

        
        <SamplePick v-model:properties="properties" :timestamp="properties.real_timestamp" />
        
        
        <v-textarea label="Note" v-model="properties.predanote" hide-details></v-textarea>
  </template>

</template>

<script setup>

import SamplePick from "@/reports/components/SamplePick";


import { onMounted } from "vue";

import baseData from '@/assets/catalog/TrackerForms.json'



const predaspeciefauna = baseData.lookup.lupopredaspeciefauna
const predasesso = baseData.lookup.sesso


const properties = defineModel("properties")

onMounted(() => {
})


// const clearSwitch = (event, key) => {
//   // console.log(event)
//   // console.log(b)

//   if (properties.value[key] === true) {
//     properties.value[key] = null
//     event.preventDefault()
//   }

// }



</script>

<style scoped></style>
